import {NatureVoyage} from "@domain/prestation/nature-voyage";

/**
 * Représente un type de charge
 *
 * @author Laurent Convert
 * @date 05/07/2023
 */
export class TypeCharge {
	/** Identifiant du type charge */
	idTypeCharge: number;

	/** Code du type charge */
	code: string;

	/** Libellé du type charge */
	libelle: string;

	/** Format du type charge (Fournisseur...) */
	idTypeFile: string;

	/** Nature du type charge */
	codeFamille: NatureVoyage;

	/**
	 * Constructeur
	 *
	 * @param dto Objet source
	 */
	constructor(dto?: any | TypeCharge) {
		//Vérification du passage d'un dto
		if (dto) {
			//Copie des propriétés
			Object.assign(this,dto);
		}
	}
}